let isDragging = false;
let pendingPreviewAfterDragEnd: (() => void) | null = null;

export function notifySlideDragStart(): void {
    isDragging = true;
}

export function notifySlideDragEnd(): void {
    isDragging = false;

    if (pendingPreviewAfterDragEnd) {
        const runPendingPreview = pendingPreviewAfterDragEnd;
        pendingPreviewAfterDragEnd = null;
        runPendingPreview();
    }
}

export function isSlideElementDragging(): boolean {
    return isDragging;
}

export function deferPreviewUntilDragEnds(runPreview: () => void): void {
    pendingPreviewAfterDragEnd = runPreview;
}
